import useAlerts from 'components/Alerts/useAlerts';
import { get, isArray } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useActions } from 'utils/hooks/useActions';
import { useAppInfo } from 'utils/hooks/useAppInfo';
import { generateIID } from 'utils/study';

const useSendDocument = () => {
  const { archives } = useAppInfo();
  const { addErrorAlert } = useAlerts();
  const { resetStudies, setBulkStudies } = useActions();
  const { t } = useTranslation('ClinicalPortal');
  const navigate = useNavigate();

  const prepareObjectForGetStudyByStudyIdentity = (requestedDocuments: any) => {
    let studyIdentities: any[] = [];
    for (const requestedDocument of requestedDocuments) {
      const studyInstanceUid = get(requestedDocument, 'externalId');
      for (const archive of archives) {
        studyIdentities.push({ archive: { id: archive.id }, studyInstanceUid });
      }
    }
    return studyIdentities;
  };

  const setBulkStudiesForSendAndNavigateToStudyDetail = (
    studiesResponse: any,
    masterPatientId: string,
  ) => {
    if (isArray(studiesResponse) && studiesResponse.length > 0) {
      for (const study of studiesResponse) {
        study.iid = generateIID(study);
      }
      resetStudies('send');
      setBulkStudies({
        type: 'send',
        items: studiesResponse,
      });
      navigate(`/studies/send/detail?from=clinicPortal&backTo=${masterPatientId}`);
    } else {
      addErrorAlert(t('noStudiesFoundInArchive'));
    }
  };

  return {
    prepareObjectForGetStudyByStudyIdentity,
    setBulkStudiesForSendAndNavigateToStudyDetail,
  };
};

export default useSendDocument;
